import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { style: {"width":"200"} }
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = {
  key: 0,
  class: "type-data-mini"
}
const _hoisted_9 = {
  key: 1,
  class: "type-data-mini"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "emq-table-footer" }

import {
  getUserWalletTransactions,
  getUserWalletInfo,
  applyUserWalletRecharge,
  applyUserWalletRefund,
  applyUserWalletWithhold,
} from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import ShowEnumOrderOP from '@/components/ShowEnumOrderOP.vue'
import PaymentOrderStatus from '@/components/PaymentOrderStatus.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkMenuShow } from '@/store/tool'
import { dateFormat } from '@/common/tools'
import UserWalletRecharge from './UserWalletRecharge.vue'
import UserWalletRefund from './UserWalletRefund.vue'
import UserWalletWithhold from './UserWalletWithhold.vue'


import { defineComponent, ref, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'UserWallet',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  userID: {
    type: String,
    required: true,
  },
  operatorID: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { getCurrencySymbol, getPaymentChannelDesc } = useProtocolEnums()

const { t } = useI18nTl('Operation')

const showRechargeDialog = ref(false)
const showRefundDialog = ref(false)
const showWithholdDialog = ref(false)

const wallet = ref<Record<string, any>>({
  balance: 0,
  principal: 0,
  gift: 0,
  currency: 0,
})
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})

const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')



const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas()
}

const recharge = async () => {
  showRechargeDialog.value = true
}

const refund = async () => {
  showRefundDialog.value = true
}

const withhold = async () => {
  showWithholdDialog.value = true
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, name, enable, operatorID, sn } = params
  newParams = {
    id: id || undefined,
    name: name || undefined,
    enable: enable || undefined,
    operatorID: operatorID || undefined,
    sn: sn || undefined,
  }
  return newParams
}

const loadWallet = async () => {
  try {
    const res = await getUserWalletInfo({ userID: props.userID, operatorID: props.operatorID })
    wallet.value = res.wallet
  } catch (error) {
    console.log(error)
  }
}

const loadDatas = async () => {
  lockTable.value = true

  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
    userID: props.userID,
  }

  try {
    const { list = [], pageReply = {} } = await getUserWalletTransactions(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
    lockTable.value = false
  } finally {
    lockTable.value = false
  }
}
const reloadDatas = () => {
  loadWallet()
  loadDatas()
}

reloadDatas()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.balance')) + ": " + _toDisplayString(Number(wallet.value.balance).toFixed(2)) + " " + _toDisplayString(_unref(getCurrencySymbol)(wallet.value.currency)), 1)
            ]),
            _: 1
          }),
          (wallet.value.gift > 0)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: "primary",
                effect: "plain",
                size: "small",
                hit: false,
                class: "custom-badge",
                round: "",
                style: {"top":"0","right":"0","margin-top":"-10px","margin-right":"-10px","z-index":"2000"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.gift')) + ": " + _toDisplayString(Number(wallet.value.gift).toFixed(2)) + " " + _toDisplayString(_unref(getCurrencySymbol)(wallet.value.currency)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (recharge()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.recharge')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'walletTransactionCtrl']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (refund()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refund')), 1)
          ]),
          _: 1
        })), [
          [_directive_role, 'walletRefundCtrl']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (withhold()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.withhold')), 1)
          ]),
          _: 1
        })), [
          [_directive_role, 'walletWithholdCtrl']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadDatas
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            label: _ctx.$t('Order.time')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('Order.tradeTime')) + ": " + _toDisplayString(_unref(dateFormat)(Number(row.order.createdAt) * 1000)), 1),
                  (row.order.settlementTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('Order.settlementTime')) + ": " + _toDisplayString(_unref(dateFormat)(Number(row.order.settlementTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('Order.settlementTime')) + ": --", 1))
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "100",
            label: _ctx.$t('Base.type'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.order.id,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(ShowEnumOrderOP, {
                    state: row.order.paymentOp
                  }, null, 8, ["state"])
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "100",
            label: _ctx.$t('Base.state'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PaymentOrderStatus, {
                state: row.order.orderState
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "order.receivableAmount",
            "min-width": "80",
            label: _ctx.$t('Order.paidAmount'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(Number(row.order.receivableAmount).toFixed(2)) + " " + _toDisplayString(_unref(getCurrencySymbol)(row.order.currency)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "order.discountAmount",
            "min-width": "80",
            label: _ctx.$t('Order.discountOrGiftAmount'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              (row.order.discountAmount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(Number(row.order.discountAmount).toFixed(2)) + " " + _toDisplayString(_unref(getCurrencySymbol)(row.order.currency)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, " -- "))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "order.final",
            "min-width": "80",
            label: _ctx.$t('Order.finallyAmount'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(Number(row.order.final).toFixed(2)) + " " + _toDisplayString(_unref(getCurrencySymbol)(row.order.currency)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "100",
            label: _ctx.$t('Order.Payment'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(getPaymentChannelDesc)(row.order.paymentChannel)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "order.balance",
            "min-width": "80",
            label: _ctx.$t('Order.balanceAfterTrade'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(Number(row.order.balance).toFixed(2)) + " " + _toDisplayString(_unref(getCurrencySymbol)(row.order.currency)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[3] || (_cache[3] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ]),
      (_unref(checkMenuShow)('walletTransactionCtrl'))
        ? (_openBlock(), _createBlock(UserWalletRecharge, {
            key: 0,
            modelValue: showRechargeDialog.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showRechargeDialog).value = $event)),
            userID: props.userID,
            operatorID: props.operatorID,
            currency: wallet.value.currency,
            onSubmitted: reloadDatas
          }, null, 8, ["modelValue", "userID", "operatorID", "currency"]))
        : _createCommentVNode("", true),
      (_unref(checkMenuShow)('walletRefundCtrl'))
        ? (_openBlock(), _createBlock(UserWalletRefund, {
            key: 1,
            modelValue: showRefundDialog.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showRefundDialog).value = $event)),
            userID: props.userID,
            balance: wallet.value.balance,
            onSubmitted: reloadDatas
          }, null, 8, ["modelValue", "userID", "balance"]))
        : _createCommentVNode("", true),
      (_unref(checkMenuShow)('walletWithholdCtrl'))
        ? (_openBlock(), _createBlock(UserWalletWithhold, {
            key: 2,
            modelValue: showWithholdDialog.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showWithholdDialog).value = $event)),
            userID: props.userID,
            currency: wallet.value.currency,
            principal: wallet.value.principal,
            gift: wallet.value.gift,
            onSubmitted: reloadDatas
          }, null, 8, ["modelValue", "userID", "currency", "principal", "gift"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})